export class CacheName {
  static readonly Static = {
    AppPreferences: 'applicationPreferences',
    Messages: 'messages',
    TypeGroups: 'typeGroups',
    TypeRefs: 'typeRefs',
    StatRefs: 'statRefs',
    MasterEntityData: 'masterEntityData'
  };
}
